module.exports = __webpack_public_path__ + "img/7.805db7fd.jpg";